export default "__VITE_ASSET__Chl7raz___"